import type { MonospaceKeyStorage } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const KeyStorage = withItemType<MonospaceKeyStorage>().defineCollection({
	name: 'MonospaceKeyStorage',
	scopeId: MONOSPACE_SCOPE_ID,
	getKey: (item) => item.key,
	meta: {
		defaultFields: ['key', 'value', 'ownerId', 'blockId', 'collectionId'],
		endpoint: 'key-storage',
	},
});
